export default "__VITE_ASSET__55a21f22__"